import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ProjectFormLayout from "layouts/ProjectFormLayout";
import themeProps from "theme/themes";
import { ProjectDto } from "common/dtos/ProjectDto";

interface ProjectDescriptionProps {
  projectData: ProjectDto;
  setProjectData: any;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Input = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid ${(state: themeProps) => state.theme.border.secondary};
  outline: none;
  resize: none;
  font-family: inherit;
`;

const ProjectDescription = ({
  projectData,
  setProjectData,
}: ProjectDescriptionProps) => {
  const { t } = useTranslation("project");

  return (
    <ProjectFormLayout title={t("addDescription")}>
      <Wrapper>
        <Input
          autoFocus
          value={projectData.description}
          onChange={(e) =>
            setProjectData({
              ...projectData,
              description: e.target.value,
            })
          }
        />
      </Wrapper>
    </ProjectFormLayout>
  );
};

export default ProjectDescription;
